module.exports = __webpack_public_path__ + "static/media/ic_sebi_white.15dce18a.svg";